import { SeekBar, PlayToggle, MuteToggle, VideoBackgroundGroup, VideoBackgroundGroups } from "./lib/controls";

window.SeekBar = SeekBar;
window.PlayToggle = PlayToggle;
window.MuteToggle = MuteToggle;
window.VideoBackgroundGroup = VideoBackgroundGroup;
window.VideoBackgroundGroups = VideoBackgroundGroups;
